// extracted by mini-css-extract-plugin
export default {"no_hover":"NotificationList_no_hover__8x0oM","wrap_text":"NotificationList_wrap_text__mqZVa"};